import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { values, flatten } from 'lodash';
import BuildHealthDispatcherPieStatsComponent
  from './../Components/BuildHealthDispatcherPieStatsComponent';
import {
  getBuildHealthInfo,
  groupDispatchersByType,
  buildsById
} from './../reducers';
import {
  buildHealth as buildHealthSelector,
  annotation as annotationSelectors
} from './../selectors';
import {
  Col,
  Row
} from 'react-bootstrap';
import {
  scenarios as scenarioHelper,
  dispatcherTypes as dispatcherTypeHelper,
  annotation as annotationHelper,
  buildHealth as buildHealthHelper,
  utils
} from './../helpers';
import {
  annotations as annotationActions,
  modal as modalActions
} from './../actions';
import AddCommentModalContainer from './AddCommentModalContainer';
import ShowCommentsModalContainer from './ShowCommentsModalContainer';

class BuildHealthDispatcherPieStatsContainer extends Component {
    static propTypes = {
      dispatchersGroupByType: PropTypes.object.isRequired,
      dispatchersResultsByDispatcherIds: PropTypes.object.isRequired,
      panelStyleByDispatcherType: PropTypes.object.isRequired,
      chartWidth: PropTypes.number.isRequired,
      annotationsByDispatcherIds: PropTypes.object.isRequired,
      buildsById: PropTypes.object.isRequired,
      hasNightlyDispatchers: PropTypes.bool.isRequired,
      buildIdByDispatcherIdPairs: PropTypes.object.isRequired,
      installerLatestDispatcherIds: PropTypes.array.isRequired
    };

    removeBuildCommentByBuildId = (annotatedItem, dispatcherId) => {
      return (dispatch, getState) => {
        const userName = localStorage.getItem('userName') || '';
        const state = getState();
        const annotationsById = annotationSelectors.
          getAnnotationsByBuildIdsOrderByDate(state);
        const relevantAnnotations = annotationsById[annotatedItem.id] || [];
        const usersCurrentAnnotation = relevantAnnotations.find(
          a => a.user === userName && a.extra_info &&
           a.extra_info.dispatcher_id === dispatcherId);
        if (usersCurrentAnnotation) {
          dispatch(annotationActions.removeBuildComment(usersCurrentAnnotation.id));
        }
      };
    }

    render() {
      const {
        dispatchersGroupByType,
        dispatchersResultsByDispatcherIds,
        panelStyleByDispatcherType,
        chartWidth,
        annotationsByDispatcherIds,
        buildsById,
        hasNightlyDispatchers,
        buildIdByDispatcherIdPairs,
        installerLatestDispatcherIds
      } = this.props;
      if (values(dispatchersResultsByDispatcherIds).filter(r => r).length === 0)
      {
        return null;
      }
      const dispatchersResults = values(dispatchersResultsByDispatcherIds);
      if (dispatchersResults.every(r => Object.keys(r).length === 0))
      {
        const label = hasNightlyDispatchers ?
          'Loading Dispatcher Cards ...' :
          'No Nightly Dispatcher Cards';
        return (
          <div>
            <Row>
              <Col mdOffset={5}>
                <label style={{ 'fontSize': 16 }}> {label} </label>
              </Col>
            </Row>
          </div>
        );
      }

      let pendingCharts = [];
      let currentWidth = 0;
      const charts = [];
      const keys = Object.keys(dispatchersGroupByType);

      //When STS-2320 gets fixed, this sort could be removed
      //Adding it here just to move case metrics type to the keys front
      //So that the name loop won't mess up the charts push
      keys.sort((a, b) => a === dispatcherTypeHelper.CASEMETRICS ?
        -1 : b === dispatcherTypeHelper.CASEMETRICS ? 1 : 0 );
      for (let i = 0; i < keys.length; i++) {
        const dispatcherType = keys[i];
        if (!panelStyleByDispatcherType[dispatcherType])
        {
          continue;
        }
        //This analyzing name loop should be removed when STS-2320 is fixed
        //And title should just be the dispatcherType
        const dispatchersByNames = utils.propertyAccumulatorReducer(
          dispatchersGroupByType[dispatcherType], 'name');
        for (const name in dispatchersByNames)
        {
          const dispatchers = dispatchersByNames[name];
          const title = dispatcherType === dispatcherTypeHelper.CASEMETRICS ?
            (name.includes('engine')) ?
              dispatcherType + '(Engine)' :
              dispatcherType :
            dispatcherType;
          const latestValidDispatcher = buildHealthHelper.
            getLatestValidDispatcherIdAndScenarios(dispatcherType,
              dispatchers, dispatchersResultsByDispatcherIds,
              installerLatestDispatcherIds);
          const scenarioSummary = latestValidDispatcher.scenariosSummary;
          const scenarioCounts = values(scenarioSummary).reduce((a, b) => a + b, 0);
          const pieData = scenarioHelper.getStateCountsFromSummary(
            latestValidDispatcher.scenariosSummary);
          const pieDataPercentage = scenarioHelper.getStatePercentages(
            pieData, scenarioCounts);
          const dashboardLink = dispatcherTypeHelper.
            getDispatcherPageLink(dispatcherType, latestValidDispatcher.number, name);
          const panelStyle = dispatcherType !== dispatcherTypeHelper.CASEMETRICS ?
            panelStyleByDispatcherType[dispatcherType].panelStyle :
            title.toLowerCase().includes('engine') ?
              panelStyleByDispatcherType[dispatcherTypeHelper.ENGINEMETRICS].panelStyle :
              panelStyleByDispatcherType[dispatcherType].panelStyle;
          const pieDataRows = [];
          pieDataRows.push(
            <Row key={name.concat('total')}>
              {scenarioCounts} total tests run
            </Row>
          );
          Object.keys(pieDataPercentage).forEach(key => {
            pieDataRows.push(<Row key={key}>
              { pieDataPercentage[key]['count'] } {key.toLowerCase()}
              ({pieDataPercentage[key]['percentage']})
            </Row>);
          });

          const DispatcherCardBuildId =
           buildIdByDispatcherIdPairs[latestValidDispatcher.id];
          const annotatedItem = buildsById[DispatcherCardBuildId];

          pendingCharts.push(
            <Col key={name} md={chartWidth}>
              <BuildHealthDispatcherPieStatsComponent
                {...this.props} {...panelStyle} pieData={pieData}
                pieDataPercentage={pieDataPercentage} title={title}
                buildId={DispatcherCardBuildId}
                dashboardLink={dashboardLink}
                dispatcherNumber={latestValidDispatcher.numbersGroup.join(',')}
                dispatcherId={latestValidDispatcher.id}
                dispatcherType={dispatcherType}
                pieDataPercentageRows={pieDataRows}
                annotatedItem={annotatedItem}
              />
            </Col>
          );
          currentWidth += chartWidth;
        }

        if (currentWidth === 12 || currentWidth + chartWidth > 12 ||
            i === keys.length - 1) {
          charts.push(
            <Row key={i}>
              {pendingCharts}
            </Row>
          );

          pendingCharts = [];
          currentWidth = 0;
        }
      }

      return (
        <div>
          <AddCommentModalContainer
            addCommentAction={annotationActions.addBuildComment}
            preSubmitAction={this.removeBuildCommentByBuildId}
            statusList={annotationHelper.getBuildFeedbackStatusList()}
            ticketStatusFunc={() => null}
          />
          <ShowCommentsModalContainer
            annotations={annotationsByDispatcherIds}
            glyphFunc={() => null}
            removeCommentAction={annotationActions.removeBuildComment}
            buildHealthPage
          />
          {charts}
        </div>
      );
    }
}


export const mapStateToProps = (state, ownProps) => {
  const buildIds = getBuildHealthInfo(state).buildIds;

  const dispatchersByBuildIds = buildHealthSelector.
    getBuildHealthPageDispatchersByBuildIds(state);
  const allDispatchers = flatten(values(dispatchersByBuildIds));
  const dispatchersBySelectedBuildIds = buildIds.reduce((result, buildId) => {
    const dispatchers = dispatchersByBuildIds[buildId] || [];
    result = dispatchers.length > 0 ? result.concat(dispatchers) : result;
    return result;
  }, []);

  const annotationsByDispatcherIds = buildHealthSelector.
    getAnnotationsByDispatcherIds(state);

  const panelStyleByDispatcherType = buildHealthSelector.
    getPanelStylesByDispatcherType(state);

  const dispatchersResultsByDispatcherIds = buildHealthSelector.
    getResultsByDispatcherIds(state);
  const installerLatestDispatcherIds = buildHealthSelector.
    getUIInstallerLatestDispatcherIds(state)(buildIds);

  const props =
  {
    annotationsByDispatcherIds,
    buildsById: buildsById(state),
    panelStyleByDispatcherType,
    dispatchersGroupByType: groupDispatchersByType(dispatchersBySelectedBuildIds),
    dispatchersResultsByDispatcherIds,
    buildIdByDispatcherIdPairs: buildHealthSelector.
      getBuildIdByDispatcherIdPairs(state) || {},
    hasNightlyDispatchers: Object.keys(dispatchersBySelectedBuildIds).length > 0 ||
     allDispatchers.length === 0,
    installerLatestDispatcherIds,
    chartWidth: ownProps.chartWidth
  };

  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onShowCommentsClick: (annotatedItem, dispatcherId) =>
      dispatch(modalActions.showCommentHistory(true, annotatedItem, dispatcherId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuildHealthDispatcherPieStatsContainer);


// WEBPACK FOOTER //
// src/Containers/BuildHealthDispatcherPieStatsContainer.jsx